import React, { Component, Fragment } from 'react'
import { Button, Modal } from '@cloud/atom-ui'
import Cropper from 'react-cropper'
import "cropperjs/dist/cropper.css"
import './coroperModal.less'
import {urlDomainDeal} from "@src/utils/common";

class coroperModal extends Component {
  state = {
    cutUrl: '',
    title: '图标'
  }
  _cropper = null
  _crop = (event) => {
    const croppedCanvas = this._cropper.getCroppedCanvas({
      width: 128,
      height: 128,
      minWidth: 128,
      minHeight: 128,
      maxWidth: 4096,
      maxHeight: 4096,
      imageSmoothingEnabled: true,
      imageSmoothingQuality: 'high'
    });
    const dataUrl = this.getRoundedCanvas(croppedCanvas, 0, 0, 128, 128, 38.4).toDataURL();
    this.setState({
      cutUrl: dataUrl
    })
  }

  cropmove = () => {
    this.setState({
      title: '剪切图标'
    })
  }

  cropend = () => {
    this.setState({
      title: '图标'
    })
  }

  handleCancel = () => {
    this.props.handleOk();
  }
  handleOk = () => {
    this.props.handleOk(this.state.cutUrl);
  }

  onCropperInitialized = (cropper) => {
    this._cropper = cropper
    cropper.setData({
      width: 128,
      height: 128,
    });
  }


  getRoundedCanvas = (sourceCanvas, x, y, width, height, radius) => {
    let canvas = document.createElement('canvas');
    let context = canvas.getContext('2d');
    canvas.width = 128;
    canvas.height = 128;
    context.imageSmoothingEnabled = true;
    context.drawImage(sourceCanvas, 0, 0, 128, 128);
    context.globalCompositeOperation = 'destination-in';
    context.beginPath();
    context.arc(x + radius, y + radius, radius, Math.PI, Math.PI * 3 / 2);
    context.lineTo(width - radius + x, y);
    context.arc(width - radius + x, radius + y, radius, Math.PI * 3 / 2, Math.PI * 2);
    context.lineTo(width + x, height + y - radius);
    context.arc(width - radius + x, height - radius + y, radius, 0, Math.PI * 1 / 2);
    context.lineTo(radius + x, height + y);
    context.arc(radius + x, height - radius + y, radius, Math.PI * 1 / 2, Math.PI);
    context.closePath();
    context.fill();
    return canvas;
  }

  cropperHtml = (src, cutUrl) => {
    return (
      <div className="cropper-wrap">
        <Cropper
          zoom={() => { }}
          cropstart={() => { }}
          cropmove={this.cropmove}
          cropend={this.cropend}
          style={{ height: 260, width: 260 }}
          aspectRatio={16 / 16}
          crop={(event) => {
            this._crop(event)
          }}
          src={urlDomainDeal(src)} //图片路径，即是base64的值，在Upload上传的时候获取到的
          preview=".uploadCrop"
          viewMode={1} //定义cropper的视图模式
          zoomable={true} //是否允许放大图像
          movable={true}
          guides={true} //显示在裁剪框上方的虚线
          background={false} //是否显示背景的马赛克
          rotatable={true} //是否旋转
          cropBoxResizable={true}
          cropBoxMovable={true}
          dragMode="move"
          center={true}
          onInitialized={this.onCropperInitialized.bind(this)}
        />
        <div className="pre-view">
          <span>预览</span>
          <div>
            <img src={urlDomainDeal(cutUrl)} alt="" />
          </div>

        </div>

      </div>
    )
  }

  render() {
    let { src, cropVisible } = this.props;
    let { cutUrl, title } = this.state;
    return (
      <Fragment>
        <canvas ></canvas>
        <Modal title={title} visible={cropVisible}
          maskClosable={false}
          width={526}
          height={435}
          onCancel={this.handleCancel}
          footer={[
            <Button
              key="submit"
              type="primary"
              style={{ fontSize: 12 }}
              onClick={e => this.handleOk()}
            >确定</Button>,
            <Button
              key="cancel"
              type="default"
              style={{ fontSize: 12 }}
              onClick={e => this.handleCancel()}
            >取消</Button>
          ]}>

          {this.cropperHtml(src, cutUrl)}
        </Modal>
      </Fragment>

    )
  }
}

export default coroperModal
